import React from "react";

import DutyStatusManagementContent from "../components/duty-status-management/duty-status-management";

const DutyStatusManagement = () => {
  return <DutyStatusManagementContent />;
};

export default DutyStatusManagement;
